import { Injectable } from '@angular/core';
import {
    IProcessReportSearchFormValue
} from "app_sasha/pages/process-report/components/process-report-search-form/process-report-search-form.component";
import { IProcessReportSearchParams } from "app_sasha/pages/process-report/process-report-page.component";
import {
    EProcessReportSearchParts
} from "app_sasha/pages/process-report/components/process-report-search-form/e-process-report-search-parts";
import * as moment from "moment";
import { ISummary } from "libraries/component/search-summary/ISummary";
import { DateService } from "libraries/date/date.service";
import { IWenji } from "libraries/interfaces/IWenji";
import { Yii } from "libraries/interfaces/Yii";
import { LabelService } from "libraries/service/label/label.service";
import { EHosts } from "libraries/enums/EHosts";
import { IPaginationRecordset } from "libraries/component/pagination/IPagination";
import {
    ENavigationDirection,
    INavigationOutput
} from "app_sasha/pages/process-report/components/process-report-table/process-report-table.component";
import { Wording } from "app_sasha/pages/process-report/components/process-report-search-form/wording";
import { EProcessReportStatus, IProcessReportSearchRequest } from "libraries/interfaces/process-report/i-process-report-response";

declare const wenji: IWenji;

@Injectable()
export class QueryParamsMappingService {

    constructor(
        private readonly dateService: DateService,
        private readonly labelService: LabelService,
    ) {
    }

    public mapFormToUrl(formValue: IProcessReportSearchFormValue): IProcessReportSearchParams {
        return this.removeEmpty(
            {
                creMin: this.dateToApiString(formValue[EProcessReportSearchParts.whenCreated][EProcessReportSearchParts.whenCreatedMin]),
                creMax: this.dateToApiString(formValue[EProcessReportSearchParts.whenCreated][EProcessReportSearchParts.whenCreatedMax]),
                // canMin: this.dateToApiString(formValue[EProcessReportSearchParts.whenCancelled][EProcessReportSearchParts.whenCancelledMin]),
                // canMax: this.dateToApiString(formValue[EProcessReportSearchParts.whenCancelled][EProcessReportSearchParts.whenCancelledMax]),
                host: this.getStringArray(formValue[EProcessReportSearchParts.hostCodeArray]),
                st: this.getStringArray(formValue[EProcessReportSearchParts.statusArray]),
            }
        );
    }

    public mapPaginationToUrl(navigationOutput: INavigationOutput, params: IProcessReportSearchParams): IProcessReportSearchParams {
        return this.removeEmpty({
            ...params,
            pcount: navigationOutput.count || 50,
            pnext: navigationOutput.direction === ENavigationDirection.next ? navigationOutput.id : null,
            pprev: navigationOutput.direction === ENavigationDirection.prev ? navigationOutput.id : null,
        });
    }

    public mapUrlToApi(params: IProcessReportSearchParams, recordset?: IPaginationRecordset): IProcessReportSearchRequest {
        return {
            recordset,
            action: {
                hostCodeArray: this.getStringArray(params.host) as EHosts[],
                statusArray: this.getStringArray(params.st) as EProcessReportStatus[],
                whenCreated: {
                    min: {date: params.creMin},
                    max: {date: params.creMax},
                },
                // whenCancelled: {
                //     min: {date: params.canMin},
                //     max: {date: params.creMax},
                // },
            }

        };
    }

    public mapUrlToForm(params: IProcessReportSearchParams): IProcessReportSearchFormValue {
        const output: IProcessReportSearchFormValue = {
            hostCodeArray: this.getStringArray(params.host),
            statusArray: this.getStringArray(params.st)
        };
        if (params.creMin) {
            output[EProcessReportSearchParts.whenCreated] = {
                whenCreatedMin: new Date(params.creMin),
                whenCreatedMax: new Date(params.creMax),
            };
        }
        // if(params.canMin){
        //     output[EProcessReportSearchParts.whenCancelled] = {
        //         [EProcessReportSearchParts.whenCancelledMin]: new Date(params.canMin),
        //         [EProcessReportSearchParts.whenCancelledMax]: new Date(params.canMax),
        //     };
        // }
        return output;
    }

    public mapFormtoSummary(formValue: IProcessReportSearchFormValue): ISummary[] {
        let summary: ISummary[];
        if (formValue) {
            const formWording: Wording = new Wording();

            summary = [];
            if (formValue[EProcessReportSearchParts.hostCodeArray]) {
                if (formValue[EProcessReportSearchParts.hostCodeArray].length > 5) {
                    summary.push(
                        {
                            field: EProcessReportSearchParts.hostCodeArray,
                            label: formWording.systems,
                            value: this.labelService.completeLabel(
                                Yii.t('wui-shared-js', '%placeholder% options sélectionnées'),
                                {
                                    placeholder: formValue[EProcessReportSearchParts.hostCodeArray].length.toString()
                                }
                            )
                        }
                    );
                } else {
                    summary.push(
                        {
                            field: EProcessReportSearchParts.hostCodeArray,
                            label: formWording.systems,
                            value: formValue[EProcessReportSearchParts.hostCodeArray].join(', ')
                        }
                    );
                }

            }
            if (formValue[EProcessReportSearchParts.statusArray]) {

                summary.push(
                    {
                        field: EProcessReportSearchParts.statusArray,
                        label: formWording.status,
                        value: formValue[EProcessReportSearchParts.statusArray].join(', ')
                    }
                );


            }
            if (formValue[EProcessReportSearchParts.whenCreated]) {
                summary.push(
                    {
                        isRequired: true,
                        field: EProcessReportSearchParts.whenCreatedMin,
                        label: formWording[EProcessReportSearchParts.whenCreatedMin],
                        value: this.dateService.formatDateForDisplay(
                            formValue[EProcessReportSearchParts.whenCreated][EProcessReportSearchParts.whenCreatedMin],
                        )
                    }
                );
                summary.push(
                    {
                        isRequired: true,
                        field: EProcessReportSearchParts.whenCreatedMin,
                        label: formWording[EProcessReportSearchParts.whenCreatedMax],
                        value: this.dateService.formatDateForDisplay(
                            formValue[EProcessReportSearchParts.whenCreated][EProcessReportSearchParts.whenCreatedMax],
                        )
                    }
                );
            }
            // if(formValue[EProcessReportSearchParts.whenCancelled]){
            //     summary.push(
            //         {
            //             isRequired: true,
            //             field: EProcessReportSearchParts.whenCancelledMin,
            //             label: formWording[EProcessReportSearchParts.whenCancelledMin],
            //             value: this.dateService.formatDateForDisplay(
            //                 formValue[EProcessReportSearchParts.whenCancelled][EProcessReportSearchParts.whenCancelledMin],
            //             )
            //         }
            //     );
            //     summary.push(
            //         {
            //             isRequired: true,
            //             field: EProcessReportSearchParts.whenCancelledMin,
            //             label: formWording[EProcessReportSearchParts.whenCancelledMax],
            //             value: this.dateService.formatDateForDisplay(
            //                 formValue[EProcessReportSearchParts.whenCancelled][EProcessReportSearchParts.whenCancelledMax],
            //             )
            //         }
            //     );
            // }
        }
        return summary;
    }


    public removeEmpty(object: IProcessReportSearchParams): IProcessReportSearchParams {
        Object.keys(object).forEach((key: string): void => {
            // If Object recall function, keep in mind : Array is Object in JS
            if (object[key] && typeof object[key] === 'object') {
                // Recursion
                // @ts-ignore
                this.removeEmpty(object[key]);

                // If object is empty then delete it
                if (!Object.keys(object[key]).length) {
                    // tslint:disable-next-line:no-dynamic-delete
                    delete object[key];
                }
            }
            // If null delete property
            else if (object[key] === null || object[key] === '' || object[key] === ' ' || object[key] === undefined) {
                // tslint:disable-next-line:no-dynamic-delete
                delete object[key];
            }
        });
        return object;
    }

    private getStringArray(input: string | string[] | null): string[] | null {
        if (input && Array.isArray(input)) {
            return input as string[];
        }
        return input && typeof input === 'string' ?
            [input] as string[] :
            null;
    }

    private dateToApiString(date: Date): string {
        return date ? moment(date).format('YYYY-MM-DD') : null;
    }
}
